export const RECORD_CHANGED_EVENT = 'buildout:record-changed';

export interface ChangedParent {
  type: string;
  id: number;
}

export type RecordChange =
  | { kind: 'activity_created'; id: number; parent: ChangedParent }
  | { kind: 'task_created'; id: number; parent: ChangedParent }
  | { kind: 'contact_updated'; id: number };

export type RecordChangeKind = RecordChange['kind'];

export const recordChanged = (change: RecordChange) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(RECORD_CHANGED_EVENT, { detail: change }));
};
